import { type CalendarDate, getLocalTimeZone, parseAbsolute, toCalendarDate } from '@internationalized/date';

type EffectiveDateBounds = {
  effectiveFromMaxValue?: CalendarDate;
  effectiveToMinValue?: CalendarDate;
};

export const getEffectiveDateBounds = (
  effectiveFrom?: string,
  effectiveTo?: string,
  timeZone = getLocalTimeZone(),
): EffectiveDateBounds => ({
  effectiveFromMaxValue: effectiveTo ? toCalendarDate(parseAbsolute(effectiveTo, timeZone)) : undefined,
  effectiveToMinValue: effectiveFrom ? toCalendarDate(parseAbsolute(effectiveFrom, timeZone)) : undefined,
});
